/** @format */

import React, { useRef, useState } from 'react'
import styled from 'styled-components'
import {
  Card,
  dayjs,
  Icon,
  Message,
  Popover,
  Table,
  TableColumn,
  Drawer,
  Form,
  FormItem,
  Input
} from '@king-design/react'
import { UserInfo } from 'src/components'

import { RecordItemProp } from '../container'
import { useAsyncFn } from 'react-use'
import { saveProcessLog, deleteProcessLog } from 'src/api/ApiEventOpsRecord'
import variable from 'src/static/styles/var'

interface LogdetailProps {
  className?: string
  WfProcessID: number
  baseInfo: RecordItemProp
  logs: RecordItemProp[]
  updateRecord: () => void
}

interface LogFormValuesProps {
  LogID?: number
  Title: string
  Remark: string
}
const initLogFormValues: LogFormValuesProps = { Title: '', Remark: '' }

const Logdetail: React.FC<LogdetailProps> = ({
  className,
  WfProcessID,
  logs,
  baseInfo,
  updateRecord
}) => {
  // 日志抽屉
  const [logDrawer, setLogDrawer] = useState(false)
  const formRef = useRef(null)
  const [formValues, setFormValues] = useState<LogFormValuesProps>(initLogFormValues)
  // 提交日志表单
  const [, fetchSaveLog] = useAsyncFn(async () => {
    const result = await saveProcessLog({
      ...formValues,
      WfProcessID
    })
    if (result) {
      Message.success('保存成功')
      updateRecord()
      setLogDrawer(false)
      setFormValues(initLogFormValues)
    }
    return result
  }, [WfProcessID, formValues])

  // 删除日志
  const [, fetchDeleteLog] = useAsyncFn(async (ID: number) => {
    const result = await deleteProcessLog({
      ID
    })
    if (result) {
      Message.success('删除成功')
      updateRecord()
    }
  }, [])

  return (
    <div className={className}>
      <Card
        title="日志详情"
        type="border"
        style={{ marginBottom: 16 }}
        slotExtra={
          baseInfo?.Type === 'published' ? (
            <a
              onClick={() => {
                setLogDrawer(true)
              }}
            >
              添加
            </a>
          ) : (
            <a className="disabled-text">添加</a>
          )
        }
      >
        <Table data={logs || []} animation={false} rowKey={record => record.ID} checkType="none">
          <TableColumn
            key="Username"
            title="用户"
            slotTemplate={([{ Username }]) => {
              return <UserInfo name={Username} />
            }}
          />
          <TableColumn key="Title" title="标题" />
          <TableColumn key="Method" title="操作类型" />
          <TableColumn
            key="CreatedAt"
            title="操作时间"
            slotTemplate={([{ CreatedAt }]) => {
              return <span>{dayjs(CreatedAt).format('YYYY-MM-DD HH:mm:ss')}</span>
            }}
          />
          <TableColumn key="Remark" title="操作备注" width="400" />
          <TableColumn
            key="Operations"
            title="操作"
            width="80"
            slotTemplate={([recourd]) => {
              const { ID, Method, Title, Remark } = recourd
              return Method === '备注' ? (
                <div className="ksc-space">
                  <Popover
                    title="确定删除？"
                    onOk={() => {
                      fetchDeleteLog(ID)
                    }}
                    size="small"
                  >
                    <a>
                      <Icon className="k-icon-delete" />
                    </a>
                  </Popover>
                  <a>
                    <Icon
                      onClick={() => {
                        setLogDrawer(true)
                        setFormValues({
                          Title,
                          Remark,
                          LogID: ID
                        })
                      }}
                      className="k-icon-edit"
                    />
                  </a>
                </div>
              ) : (
                '-'
              )
            }}
          />
        </Table>
      </Card>

      <Drawer
        value={logDrawer}
        width={600}
        title="日志"
        mode="destroy"
        onChangeValue={show => {
          if (!show) {
            setLogDrawer(false)
            setFormValues(initLogFormValues)
          }
        }}
        ok={async () => {
          const validate = await formRef.current.validate()
          if (validate) {
            fetchSaveLog()
          }
        }}
      >
        <Form starOnRequired ref={formRef} labelWidth={100} className="form_content">
          <FormItem label="标题" value={formValues.Title} rules={{ required: true }}>
            <Input
              width={450}
              value={formValues.Title}
              onChangeValue={value => {
                setFormValues({ ...formValues, Title: value })
              }}
            />
          </FormItem>
          <FormItem label="备注信息" value={formValues.Remark} rules={{ required: true }}>
            <Input
              width={450}
              type="textarea"
              rows={4}
              value={formValues.Remark}
              onChangeValue={value => {
                setFormValues({ ...formValues, Remark: value })
              }}
            />
          </FormItem>
        </Form>
      </Drawer>
    </div>
  )
}

export default styled(Logdetail)`
  .k-icon {
    cursor: pointer;
    transition: all ease-in-out 0.3s;
    &:hover {
      color: ${variable.primaryColor};
    }
  }
`
